import { Cog8ToothIcon } from "@vericus/cadmus-icons";
import { ControlButton, DropdownMenu, vars } from "@vericus/cadmus-ui";

import { useNavigate } from "react-router-dom";

/** Settings menu */
export function Settings() {
  const navigate = useNavigate();

  const onLogout = () => {
    navigate("/logout");
  };

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <ControlButton
          style={{ padding: 0 }}
          aria-label={"Settings"}
          icon={<Cog8ToothIcon size={28} label="" />}
        />
      </DropdownMenu.Trigger>
      <DropdownMenu.Content>
        <DropdownMenu.Label>Settings</DropdownMenu.Label>
        <DropdownMenu.Item
          onSelect={onLogout}
          style={{ color: vars.colors.failure }}
        >
          Log out and Exit
        </DropdownMenu.Item>
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
}
